module.exports = __webpack_public_path__ + "static/img/czqrcode.3c213e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/czqrcode.png
// module id = 57
// module chunks = 0